import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const AdminKiosks = withLazyFallback(() => import('components/admin/pages/Kiosks/AdminKiosks'));
const KioskDashboard = withLazyFallback(
  () => import('components/admin/pages/Kiosks/KioskDashboard/KioskDashboard')
);

// Nested under the AdminIQueue route (`/admin/admin-i-queue`), so these resolve to
// `/admin/admin-i-queue/kiosks-dashboard` and `/admin/admin-i-queue/kiosks`.
const ADMIN_KIOSKS = [
  {
    path: 'kiosks-dashboard',
    element: <KioskDashboard />,
    handle: { title: 'Kiosks Dashboard' }
  },
  {
    path: 'kiosks',
    element: <AdminKiosks />,
    handle: { title: 'Kiosks' }
  }
];

export default ADMIN_KIOSKS;
